<template src="./index.html"></template>
<script>
import {
    pdf_wspz_login_success,
    query_login_status,
    queryBatchLog,
    rpa_login_success,
    send_sms,
    submit_sms
} from '@/api/organization';

export default {
    props: {
        bsdlData:{
            type: Object ,
            default: {}
        },
        logId: {
            type: Number,
            default: null
        },
        verifyLogo: {
            type: Boolean,
            default: false
        },
        smsdialog: {
            type: Boolean,
            default: false
        }
    },
    watch: {
        smsdialog: function(newVal, oldVal) {
            if (newVal) {
                this.$nextTick(() => {
                    this.drawImg();
                });
            }
        },
        logId:function(indexVal, oldVal) {
            if (indexVal) {
                this.$nextTick(() => {
                    this.drawImg();
                    this.markers = []
                })
            }
        },
    },
    data() {
        return {
            isLoggedIn: "",
            smsCode: "",
            countdown: 120,
            isDragging: false,
            isDragging2: false,
            startX: 0,
            startX2: 0,
            startY: 0,
            maxDistance: 300,
            currentDistance: 0,
            slidePercent: 0, // 滑动比例（0~100）
            slidePercent2: 0, // 滑动比例（0~100）
            defaultBg: "#e5e7eb", // 默认背景色
            currentRotation:"",
            loading: false,
            bimg:"",
            simg:"",
            imgx: "0px",
            imgy: "0px",
            imgType: "",
            successLogo: false,
            timer: null,
            bwidth: "",
            bheight: "",
            swidth: "",
            sheight: "",
            point: "",
            backgroundImage: null,
            sliceImage: null,
            markers: [] // 存储点击位置的数组
        }
    },
    mounted() {
    },
    computed: {
        gradientStyle() {
            // 渐变色仅覆盖已滑动区域，未滑动部分保持默认
            return `linear-gradient(to right, #60a5fa 0%, #3b82f6 ${this.slidePercent}%, ${this.defaultBg} ${this.slidePercent}%)`;
        },
        gradientStyle2() {
            // 渐变色仅覆盖已滑动区域，未滑动部分保持默认
            return `linear-gradient(to right, #60a5fa 0%, #3b82f6 ${this.slidePercent2}%, ${this.defaultBg} ${this.slidePercent2}%)`;
        }
    },
    methods: {
        imgClick(event) {
            let img = this.$refs.bottomImg;
            // 获取图片的位置信息
            const imgRect = img.getBoundingClientRect();

            // 获取点击位置
            const x = event.clientX - imgRect.left; // 相对位置
            const y = event.clientY - imgRect.top;
            // 存储点击位置
            this.markers.push({ x, y });
        },
        submitCode() {
            let params = [];
            let pt = {};
            if (typeof this.point === 'string') {
                pt = JSON.parse(this.point);
            } else {
                pt = JSON.parse(JSON.stringify(this.point));
            }
            params.push({"x": pt.x, "y": pt.y});
            this.markers.forEach(marker => {
                params.push({"x": marker.x,"y": marker.y});
            })
            this.currentDistance = JSON.stringify(params);
            this.verifySlider()
        },
        drawImg() {
            this.smsCode = "";
            this.loading = false;
            this.successLogo = false;
            queryBatchLog({logId: this.logId}).then((res) => {
                if (res.data.code === "1") {
                    this.bimg = res.data.data.bimg;
                    this.simg = res.data.data.simg;
                    this.imgx = res.data.data.imgx + "px";
                    this.imgy = res.data.data.imgy + "px";
                    this.imgType = res.data.data.imgType;
                    let bsize = res.data.data.bsize;
                    let ssize = res.data.data.ssize;
                    this.bwidth = bsize.split("*")[0] + "px";
                    this.bheight = bsize.split("*")[1] + "px";
                    this.swidth = ssize.split("*")[0] + "px";
                    this.sheight = ssize.split("*")[1] + "px";
                    if (this.imgType === 'rotate') {
                        this.loadImages();
                    }
                    if (res.data.data.point) {
                        if (typeof res.data.data.point === 'string') {
                            this.point = res.data.data.point;
                        } else {
                            this.point = JSON.stringify(res.data.data.point);
                        }
                    }
                }
            })
        },
        loadImages() {
            let bImgCanvas = this.$refs.backgroundCanvas;
            const ctx = bImgCanvas.getContext('2d');
            this.backgroundImage = new Image();
            this.backgroundImage.src = this.bimg; // 背景图路径
            this.backgroundImage.onload = () => {
                ctx.drawImage(this.backgroundImage, 0, 0, bImgCanvas.width, bImgCanvas.height);
            };

            this.sliceImage = new Image();
            this.sliceImage.src = this.simg; // 拼图图块路径
            this.sliceImage.onload = () => {
                this.drawCirclePiece(0); // 确保图块加载完成后绘制
            };
        },
        // 开始倒计时
        startCountdown() {
            this.countdown = 120; // 重置倒计时
            this.timer = setInterval(() => {
                if (this.countdown > 0) {
                    this.countdown--;
                } else {
                    clearInterval(this.timer);
                }
            }, 1000);
        },
        // 重新发送验证码
        handleResend() {
            send_sms({companyId: this.bsdlData.companyId, offset: -1}).then(res => {
                if (res.data.code === 1) {
                    this.$message.success(res.data.data.data.value.message);
                    this.successLogo = true;
                    this.startCountdown();
                } else {
                    this.$message.error("发送验证码失败，原因：" + res.data.msg);
                }
            });
        },
        onDragStart(e) {
            // 鼠标点击
            if (this.loading || this.successLogo) return;
            this.isDragging = true;
            this.startX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
            document.addEventListener('mousemove', this.onDragMove);
            document.addEventListener('mouseup', this.onDragEnd);
            e.preventDefault();
        },
        onDragStart2(e) {
            // 鼠标点击
            if (this.loading || this.successLogo) return;
            this.isDragging2 = true;
            this.startX2 = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
            document.addEventListener('mousemove', this.onDragMove2);
            document.addEventListener('mouseup', this.onDragEnd2);
            e.preventDefault();
        },
        calculateRotation(slideDistance, maxSlideDistance) {
            // 滑动距离线性映射到 0-360 度
            this.currentRotation = (slideDistance / maxSlideDistance) * 360;
            return this.currentRotation;
        },
        onDragMove2(e) {
            // 鼠标移入
            if (!this.isDragging2) return;
            let maxSlideDistance = this.$refs.sliderTrack2.offsetWidth - this.$refs.sliderButton2.offsetWidth;
            const clientX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
            let distance = clientX - this.startX2;
            distance = Math.max(0, Math.min(distance, maxSlideDistance)); // 300 宽度固定
            this.currentDistance = distance - 37;
            // 计算滑动比例（横向）
            const sliderRect = this.$refs.sliderTrack2.getBoundingClientRect();
            const offsetX = e.clientX - sliderRect.left;
            this.slidePercent2 = Math.min(100, Math.max(0, (offsetX / sliderRect.width) * 100));
            // 计算旋转角度
            const rotation = this.calculateRotation(distance, maxSlideDistance);
            // 重新绘制圆形区域
            this.drawCirclePiece(rotation);
            this.updateUI2(distance);
            e.preventDefault();
        },
        drawCirclePiece(additionalRotation = 0) {
            let size = this.swidth.replaceAll("px", "");
            let circleCanvas = this.$refs.circleCanvas;
            const ctx = circleCanvas.getContext('2d');

            // 设置画布大小
            this.$refs.circleCanvas.width = size;
            this.$refs.circleCanvas.height = size;

            // 保存状态
            ctx.save();

            // 移动到圆心并旋转
            ctx.translate(size/2, size/2);
            ctx.rotate((additionalRotation * Math.PI) / 180);

            // 绘制图片（从背景中心截取）
            ctx.drawImage(
                this.sliceImage,-size / 2, -size / 2 - 35, this.swidth.replaceAll("px", ""), this.sheight.replaceAll("px", "")// 目标位置和大小
            );

            // 恢复状态
            ctx.restore();
        },
        onDragEnd2(e) {
            // 鼠标松开
            if (!this.isDragging2) return;
            this.isDragging2 = false;
            document.removeEventListener('mousemove', this.onDragMove2);
            document.removeEventListener('mouseup', this.onDragEnd2);
            this.loading = false;
            this.verifySlider();
            e.preventDefault();
        },
        onDragMove(e) {
            // 鼠标移入
            if (!this.isDragging) return;
            const clientX = e.type.includes('mouse') ? e.clientX : e.touches[0].clientX;
            let distance = clientX - this.startX;
            distance = Math.max(0, Math.min(distance, this.bwidth.replaceAll("px",""))); // 300 宽度固定
            this.currentDistance = distance;

            // 计算滑动比例（横向）
            const sliderRect = this.$refs.sliderTrack.getBoundingClientRect();
            const offsetX = e.clientX - sliderRect.left;
            this.slidePercent = Math.min(100, Math.max(0, (offsetX / sliderRect.width) * 100));
            this.updateUI(distance);
            e.preventDefault();
        },
        onDragEnd(e) {
            // 鼠标松开
            if (!this.isDragging) return;
            this.isDragging = false;
            document.removeEventListener('mousemove', this.onDragMove);
            document.removeEventListener('mouseup', this.onDragEnd);
            this.verifySlider();

            e.preventDefault();
        },
        verifySlider() {
          // 提交验证码
            this.loading = true; // 等待标志，等待请求时，需暂时禁止事件触发
            send_sms({companyId: this.bsdlData.companyId, offset: this.currentDistance}).then(res => {
                if (res.data.code === 1) {
                    if ("请重新移动滑块" === res.data.data.data.value.message || "请重新点击" === res.data.data.data.value.message) {
                        this.$message.error(res.data.data.data.value.message);
                        this.simg = res.data.data.data.value.simg;
                        this.bimg = res.data.data.data.value.bimg;
                        this.imgy = res.data.data.data.value.y + "px";
                        this.imgx = res.data.data.data.value.x + "px";
                        this.imgType = res.data.data.data.value.type;
                        let bsize = res.data.data.data.value.bsize;
                        let ssize = res.data.data.data.value.ssize;
                        this.bwidth = bsize.split("*")[0] + "px";
                        this.bheight = bsize.split("*")[1] + "px";
                        this.swidth = ssize.split("*")[0] + "px";
                        this.sheight = ssize.split("*")[1] + "px";
                        if (this.imgType === 'rotate') {
                            this.loadImages();
                        }
                        if (res.data.data.data.value.point) {
                            if (typeof res.data.data.data.value.point === 'string') {
                                this.point = res.data.data.data.value.point;
                            } else {
                                this.point = JSON.stringify(res.data.data.data.value.point);
                            }
                        }
                        this.successLogo = false;
                    } else {
                        this.$message.success(res.data.data.data.value.message);
                        this.successLogo = true;
                        this.startCountdown();
                    }
                } else {
                    this.$message.error("发送验证码失败，原因：" + res.data.msg);
                }
                this.loading = false;
                this.currentDistance = 0;
                if (this.imgType === 'rotate') {
                    this.slidePercent2 = 0; // 重置滑动比例
                    this.updateUI2(0); // 重置滑动按钮与滑动图片位置
                } else if (this.imgType === 'slide') {
                    this.slidePercent = 0; // 重置滑动比例
                    this.updateUI(0); // 重置滑动按钮与滑动图片位置
                } else if (this.imgType === 'click') {
                    this.markers = []
                    if ("请重新移动滑块" !== res.data.data.data.value.message && "请重新点击" !== res.data.data.data.value.message) {
                        this.point = {}
                    }
                }
            });
        },
        updateUI2(distance) {
            let sliderButton = this.$refs.sliderButton2;
            let sliderText = this.$refs.sliderText2;
            sliderText.style.opacity = distance > 50 ? '0' : '1';
            sliderButton.style.left = (distance - 1 )+ "px";
        },
        updateUI(distance) {
            let sliderButton = this.$refs.sliderButton;
            let sliderText = this.$refs.sliderText;
            let sliderPiece = this.$refs.sliderPiece;
            sliderText.style.opacity = distance > 50 ? '0' : '1';
            sliderButton.style.left = (distance - 1 )+ "px";
            sliderPiece.style.right = '-' + distance + 'px';
        },
        closediag() {
            this.$emit('closediag', false);
            this.smsCode = "";
            this.loading = false;
            this.successLogo = false;
        },
        sendVerificationCode() {
            // 模拟发送验证码
            if (this.countdown > 0) return;
            this.countdown = 60;
            this.timer = setInterval(() => {
                this.countdown--;
                if (this.countdown <= 0) {
                    clearInterval(this.timer);
                }
            }, 1000);
            send_sms({companyId: this.bsdlData.companyId}).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("验证码已经发送到您的手机");
                } else {
                    this.$message.error("发送验证码失败，原因：" + res.data.msg);
                }
            });
        },
        submitVerification() {
            if (!this.smsCode) {
                alert('请输入验证码');
                return;
            }
            submit_sms({companyId: this.bsdlData.companyId, smsCode: this.smsCode, logId: this.logId}).then(res => {
                if (res.data.code === 1) {
                    this.$message.success("验证成功");
                    pdf_wspz_login_success({companyId: this.bsdlData.companyId}).then(loginRes => {})
                    this.$emit('closediag', false);
                    this.$emit('update', true); // 触发父组件更新
                } else {
                    this.$message.error("验证失败，原因：" + res.data.msg);
                }
            })
        }
    },
    beforeDestroy() {
        // 清除定时器
        if (this.timer) {
            clearInterval(this.timer);
        }

        document.removeEventListener('mousemove', this.onDragMove);
        document.removeEventListener('mouseup', this.onDragEnd);
    }
}
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
